// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"2459a240","693":"20d086ee"}[chunkId] + ".chunk.js";
};